window.bookingtimepicker;
window.bookingpicker;

window.pickertime;
window.pickerdate;

var timestamp_booking = false;
var timestamp_order = false;

//booking picker
window.bookingSetup = function () {
    if (window.bookingtimepicker) {
        timestamp_booking = false;
        window.bookingpicker.clear().stop();
    } else {
        window.bookingtimepicker = $('#booking_dotimepicker').pickatime({
            container: 'body',
            clear: '',
            format: 'HH:i',
            formatSubmit: 'HH:i',
            interval: 10
        }).pickatime('picker');

        window.bookingpicker = $('#booking_dodatepicker').pickadate({
            container: 'body',
            min: new Date(),
            clear: '',
            firstDay: 1,
            format: 'dd.mm.yyyy',
            hiddenName: true,
            selectMonths: false,
            closeOnSelect: true,
            onSet: function (context) {
                if (context.select) {
                    buildBookingOpenHours(context.select);
                }
            }
        }).pickadate('picker');
    }

    setTimeout(() => {
        window.bookingpicker.start();
        timestamp_booking = window.bookingpicker.get('highlight').pick;
        window.bookingpicker.set('select', timestamp_booking);
    }, 0);
}

window.buildBookingOpenHours = async function (time) {
    var getHours = await window.getHours(time);

    window.bookingpicker.set('disable', false);
    window.bookingpicker.set('disable', getHours.disableBookingDays);

    var timestamp_now = window.bookingpicker.get('highlight').pick;
    if (timestamp_booking) {
        if (timestamp_booking != timestamp_now) {
            timestamp_booking = false;
            return window.bookingpicker.set('select', timestamp_now);
        } else {
            timestamp_booking = false;
        }
    }

    window.bookingtimepicker.clear().stop();
    setTimeout(() => {
        window.bookingtimepicker.start();
        window.bookingtimepicker.set({
            min: getHours.startEnd.min,
            max: getHours.startEnd.max,
            disable: [{
                from: getHours.startEnd.min,
                to: getHours.startEnd.max
            }],
            enable: getHours.hours,
            select: getHours.startEnd.min
        });
    }, 0);

    checkGuestButton(getHours.guest);
}

//modal picker
window.dateAndTime = function () {
    if (window.pickerdate) {
        timestamp_order = false;
        window.pickerdate.clear().stop();
    } else {
        window.pickertime = $('#dotimepicker').pickatime({
            container: 'body',
            clear: '',
            format: 'HH:i',
            formatSubmit: 'HH:i',
            interval: 10
        }).pickatime('picker');

        window.pickerdate = $('#dodatepicker').pickadate({
            container: 'body',
            min: new Date(),
            clear: '',
            firstDay: 1,
            format: 'dd.mm.yyyy',
            hiddenName: true,
            selectMonths: false,
            closeOnSelect: true,
            onSet: function (context) {
                if (context.select) {
                    buildPayOpenHours(context.select);
                }
            },
        }).pickadate('picker');
    }

    setTimeout(() => {
        window.pickerdate.start();
        timestamp_order = window.pickerdate.get('highlight').pick;
        window.pickerdate.set('select', timestamp_order);
    }, 0);
}

window.buildPayOpenHours = async function (time) {
    var getHours = await window.getHours(time);

    window.pickerdate.set('disable', false);
    window.pickerdate.set('disable', getHours.disableDays);

    var timestamp_now = window.pickerdate.get('highlight').pick;
    if (timestamp_order) {
        if (timestamp_order != timestamp_now) {
            timestamp_order = false;
            return window.pickerdate.set('select', timestamp_now);
        } else {
            timestamp_order = false;
        }
    }

    window.pickertime.clear().stop();
    setTimeout(() => {
        window.pickertime.start();
        window.pickertime.set({
            min: getHours.startEnd.min,
            max: getHours.startEnd.max,
            disable: [{
                from: getHours.startEnd.min,
                to: getHours.startEnd.max
            }],
            enable: getHours.hours,
            select: getHours.startEnd.min
        });
    }, 0);
}

window.getHours = async function (time = '') {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'post',
            url: window.location.origin + '/get-time',
            data: {
                date: time
            },
            success: function (data) {
                resolve(data);
            },
        });
    });
}